interface AIScoreBadgeProps {
  score: number
}

export function AIScoreBadge({ score }: AIScoreBadgeProps) {
  const color =
    score >= 80 ? '#22c55e' :
    score >= 60 ? '#06b6d4' :
    score >= 40 ? '#f59e0b' :
    '#ef4444'
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-semibold rounded-md text-white"
      style={{ backgroundColor: color }}
      title={`AI Score: ${score}/100`}
    >
      AI {score}
    </span>
  )
}
